import React from 'react';
import './Header.css';
import AuthButton from './AuthButton';

type Page = 'home' | 'services' | 'about' | 'contact' | 'quote' | 'claims' | 'safe-driving' | 'money-saving' | 'quotes-history' | 'claims-history';

interface HeaderProps {
  onNavigate: (page: Page) => void;
}

const Header: React.FC<HeaderProps> = ({ onNavigate }) => {
  const handleNavClick = (page: Page) => {
    onNavigate(page);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo" onClick={() => handleNavClick('home')} style={{ cursor: 'pointer' }}>
          <h1>PolicyPal</h1>
          <span className="tagline">Your Insurance Partner</span>
        </div>
        <nav className="nav">
          <ul className="nav-list">
            <li><button onClick={() => handleNavClick('home')} className="nav-link">Home</button></li>
            <li><button onClick={() => handleNavClick('services')} className="nav-link">Services</button></li>
            <li><button onClick={() => handleNavClick('about')} className="nav-link">About</button></li>
            <li><button onClick={() => handleNavClick('contact')} className="nav-link">Contact</button></li>
          </ul>
        </nav>
        <div className="auth-section">
          <AuthButton onNavigate={onNavigate} />
        </div>
      </div>
    </header>
  );
};

export default Header;